import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { LookupService } from "../services/lookup.service";
import { CommonDropDown } from "../common/types/dropdown.type";
import { BaseRespone } from "../models/common.response";
 
@Injectable({
    providedIn: 'root'
})
export class DoctorDropDownResolver implements Resolve<CommonDropDown[]>
{
    /**
     * Constructor
     */
    constructor(private _lookupService: LookupService) {
    }
 
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
 
    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CommonDropDown[]> {
        return this._lookupService.getDoctors();
    }
}